import { Button, Col, Row } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { CustomerData } from '../../types/customer';

type CustomerSummaryFooterProps = {
  customerData: CustomerData;
};

export const CustomerSummaryFooter: React.FC<CustomerSummaryFooterProps> = ({
  customerData,
}) => {
  const navigate = useNavigate();
  const handleOpenLink = () => {
    window.open(customerData?.urlView, '_blank');
  };
  return (
    <CustomFooter align='middle'>
      <Col
        style={{
          display: 'flex',
          gap: '16px',
        }}
      >
        <Button type='primary' onClick={handleOpenLink}>
          Ver plataforma como usuário
        </Button>
        <Button
          onClick={() => navigate(`/cliente/old/${customerData.customer.id}`)}
        >
          Ver visão antiga de clientes
        </Button>
      </Col>
    </CustomFooter>
  );
};

const CustomFooter = styled(Row)`
  height: 64px;
  width: 100%;
  padding: 0 80px;
  line-height: 64px;
  background: #1f1f1f;

  border-top: 1px solid #424242;

  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
`;
